import React, { useEffect } from "react";
import Router from "./route/Index";

import ThemeProvider from "./layout/provider/Theme";
import { ToastContainer } from "react-toastify";
import AppRoot from "./AppRoot";

const App = () => {
  return (
    <ThemeProvider>
      <AppRoot>
        <Router />
      </AppRoot>
      <ToastContainer
        position="bottom-right"
        autoClose={5000}
        hideProgressBar={false}
        newestOnTop
        closeOnClick
        pauseOnHover
        draggable
        limit={4}
      />
    </ThemeProvider>
  );
};
export default App;